'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const ModalView = require('common/ui/view/modal/index');
const ContentService = require('data/app/service/content/index');
const DataRepository = require('data/domain/repository/content/index');
const DiagramRepository = require('system/domain/repository/diagram');
const ContentEditView = require('balus/ui/view/body/process/toolbar/content-edit');
const ModelEditView = require('balus/ui/view/body/process/toolbar/diagram-edit');
const RelatedKeys = require('common/domain/value/related-keys');
const Template = require('balus/ui/template/additional/selector.hbs');

module.exports = Mn.View.extend({
    hidePrimaryRelatedKey: false,
    template: Template,
    tagName: 'span',
    ui: {
        contentAddButton: '.content-add-button',
        modelAddButton: '.model-add-button'
    },
    events: {
        'click @ui.contentAddButton': '_showContentAddModal',
        'click @ui.modelAddButton': 'showModelAddModal'
    },

    _showContentAddModal: function() {
        // そのまま呼ぶと click Event が第一引数に入ってしまうため、一度噛ませる
        this.showContentAddModal(null);
    },

    showContentAddModal: function(file) {
        const context = this.getOption('context');
        const project = context.getProject();

        let modal = new ModalView({
            model: this.model,
            title: i18n.t('balus_template_body_process:modal.add-data.title'),
            bodyView: new ContentEditView({
                context: context,
                project: project,
                file: file
            }),
            onChildviewSave: function() {
                this.disableButtons();
                const activeContents = this.getOption('bodyView').getActiveContents();
                const contentJSON = this.getOption('bodyView').getContent();
                if(activeContents && activeContents.length > 0) {
                    this.trigger('add:content', activeContents);
                } else {
                    this.trigger('content', contentJSON);
                }
            }
        });

        modal.on('content', contentJSON => {
            (new ContentService.ContentAddService({
                project: project,
                name: contentJSON.name,
                uri: contentJSON.uri,
                storageObjectId: contentJSON.storageObjectId,
                thumbnailURI: contentJSON.thumbnailURI,
                uploaded: contentJSON.uploaded,
                parentContainer: 'attachments'
            }))
                .add()
                .then(content => {
                    this.trigger('add:key', [content.key, content.getLatestVersion().key]);

                    modal.hide();
                });
        });

        modal.on('add:content', contentIDs => {
            _.each(contentIDs, contentID => {
                DataRepository.find(project)
                    .fetchContentOnce(contentID)
                    .then(content => {
                        this.trigger('add:key', [content.key, content.getLatestVersion().key]);
                    });
            });

            modal.hide();
        });

        modal.show();
    },

    showModelAddModal: function() {
        const project = this.getOption('context').getProject();

        let modal = new ModalView({
            model: this.model,
            title: i18n.t('balus_template_timeline:modal.add-model.title'),
            bodyView: new ModelEditView({
                group: this.getOption('context').getGroup(),
                project: project,
                hideNew: true
            }),
            onChildviewSave: function() {
                this.disableButtons();
                const activeModelIDs = this.getOption('bodyView').getActiveModels();
                this.trigger('add-existing-models', activeModelIDs);
            }
        });

        modal.on('add-existing-models', modelIDs => {
            const models = DiagramRepository.getDiagrams({
                context: {
                    projectId: project.id
                }
            });
            const modelKeys = _.map(modelIDs, modelID => {
                return models.get(modelID).key
            });
            this.trigger('add:key', modelKeys);

            modal.hide();
        });

        modal.show();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/additional/selector.js